import { render } from "./BBoxIntersectionPoint.vue?vue&type=template&id=7a539dc2&ts=true"
import script from "./BBoxIntersectionPoint.vue?vue&type=script&lang=ts"
export * from "./BBoxIntersectionPoint.vue?vue&type=script&lang=ts"

import "./BBoxIntersectionPoint.vue?vue&type=style&index=0&id=7a539dc2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__